import { ReactNode, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { ConfigProvider as AntdConfigProvider } from "antd";
import ptBR from "antd/locale/pt_BR";

import { StyleSheetManager } from "styled-components";

import { GlobalStyles } from "@styles/GlobalStyles";
import { createCustomTheme } from "@styles/theme";
import ThemeProvider from "@styles/ThemeProvider";

import { useClientSettings } from "@hooks/useClientSettings";

const returnTrue = () => true;

/**
 * ClientTheme composition and theme providers setup from third party such as antd/styled-components.
 */
export const StyleProvider = ({ children }: { children: ReactNode }) => {
  const client = useClientSettings();
  const location = useLocation();
  const customTheme = useMemo(
    () => createCustomTheme(client, location.pathname.includes("consignado")),
    [client, location.pathname],
  );

  return (
    <StyleSheetManager shouldForwardProp={returnTrue}>
      <AntdConfigProvider locale={ptBR} theme={customTheme}>
        <ThemeProvider>
          <>{children}</>
          <GlobalStyles />
        </ThemeProvider>
      </AntdConfigProvider>
    </StyleSheetManager>
  );
};
